// Football's words for league name ideas (B-430), added to the core's.
//
// Each list is a part of a name, and every word in it has to read right in
// every pattern that part is used in (`LeagueNameWords` says which). Kept
// out, as in the core: money and betting, a league format's name, anything
// gendered, alcohol (so no *Sunday Funday*), and a brand — the NFL's *Super
// Bowl* among them.

import type { LeagueNameWords } from '@fsp/sports-core';

export const footballLeagueNameWords: LeagueNameWords = Object.freeze({
  names: [
    'Sunday Regret',
    'Fourth and Long',
    'Fourth and Inches',
    'Third and Forever',
    'Monday Morning Quarterbacks',
    'Armchair Quarterbacks',
    'Any Given Sunday',
    'Victory Formation',
    'Two-Minute Drill',
    'Punt, Pass and Pray',
    'Prevent Defense',
    'Flags on the Play',
    'No Huddle',
    'The Kneel-Down Society',
    'Hail Mary Heroes',
    'Game of Throws',
    'Turkey Day Classic',
    'End Zone Dance Club',
    'Bye Week Blues',
    'Fumble Recovery Group',
    'Gridiron Gurus',
    'Pigskin Prophets',
    'Sunday Scaries',
    'Monday Night Miracles',
    'Thursday Night Lights',
    'Fourth Down Philosophers',
    'Ineligible Receivers',
    'Illegal Formation',
    'Delay of Game',
    'Offsetting Penalties',
    'Intentional Grounding',
    'Roughing the Kicker',
    'Unsportsmanlike Conduct',
  ],
  describing: [
    'Gridiron',
    'Pigskin',
    'Blitzing',
    'Two-Minute',
    'Red-Zone',
    'Goal-Line',
    'Play-Action',
    'No-Huddle',
    'Fourth-Down',
    'Sunday',
    'Monday Night',
    'Tailgating',
    'Hail Mary',
    'Sideline',
    'Special Teams',
    'Ineligible',
  ],
  subjects: [
    'Red Zone',
    'Goal Line',
    'Hail Mary',
    'Two-Minute Drill',
    'Fourth Down',
    'Onside Kick',
    'Pick Six',
    'End Zone',
    'Fumble',
    'Fair Catch',
    'Kneel-Down',
    'Bye Week',
    'Blitz',
    'Flea Flicker',
    'Coin Toss',
    'Two-Point Try',
    'Hard Count',
    'Victory Formation',
    'Garbage Time',
    'Missed Field Goal',
    'Practice Squad',
    'Touchback',
    'Punt Return',
    'Field Goal',
    'Touchdown',
  ],
  moments: [
    'Sunday',
    'Sunday Morning',
    'Sunday Night',
    'Monday Night',
    'Thursday Night',
    'Bye Week',
    'Waiver Wednesday',
    'Late Kickoff',
    'Early Kickoff',
    'Fourth Quarter',
    'Overtime',
    'Two-Minute Warning',
    'Red Zone',
    'Tailgate',
    'Halftime',
    'Kickoff',
    'Game Day',
    'Garbage Time',
    'Turkey Day',
  ],
  hangouts: [
    'Tailgate',
    'Pigskin',
    'Gridiron',
    'End Zone',
    'Sideline',
    'Locker Room',
    'Huddle',
    'Fifty-Yard Line',
    'Parking Lot',
    'Turkey Day',
    'Nosebleed Seats',
    'Upper Deck',
    'Press Box',
    'Bleachers',
  ],
  collections: [
    'Missed Field Goals',
    'Dropped Passes',
    'Hail Marys',
    'Fumbled Snaps',
    'Onside Kicks',
    'Sunday Scaries',
    'Bye Week Disasters',
    'Pick Sixes',
    'Fair Catches',
    'Kneel-Downs',
    'Penalty Flags',
    'Missed Tackles',
    'Shanked Punts',
    'Bad Snaps',
    'Trick Plays',
  ],
});
